import { Profile, APIResponse } from '../types/api/types';
import { getApi } from '.';
import { OnBoardingError } from '../lib/errors/OnBoardingError';
import { APIError } from '../lib/errors/api/APIError';

export const fetchProfileName = async (profileId: number): Promise<string> => {
  const { data } = await getApi().profiles.get<APIResponse<Profile>>({
    profileId,
  });

  if (!data.name) {
    throw new Error('Invalid profile data!');
  }

  return data.name;
};

/**
 * Fetch all the account profiles
 */
export const fetchUserProfiles = async () => {
  const { data } = await getApi().profiles.get<APIResponse<Profile[]>>();
  return data;
};

/**
 * Creates a new profile for this account
 */
export const createProfile = async (profileName: string) => {
  const body = {
    name: profileName,
    birth_date: '1900-01-01',
    gender: 'MALE',
    order: '1',
  } as const;
  try {
    const { data } = await getApi().profiles.post<APIResponse<Profile>>(body);
    return data;
  } catch (error) {
    if (typeof error === 'object' && (error as APIError).status) {
      throw new OnBoardingError(
        `Error creating the profile ${profileName}`,
        (error as APIError).status
      );
    }
    throw error;
  }
};

export const getProfileID = async (profileName: string) => {
  const userProfiles = await fetchUserProfiles();
  const filterProfiles = userProfiles.filter(
    profile => profile.name === profileName
  );
  if (filterProfiles.length > 0) {
    return filterProfiles[0].id;
  }
};
